import axios from "axios";
import configs from "../configs";

const header = {
  "Content-Type": "application/json",
  "Access-Control-Request-Method": "POST",
};

const instance = axios.create({
  baseURL: configs.api.baseUrl,
  //timeout: 20000,
});

export const createStoreV2 = (body) =>
  instance.post("/create-store-v2", body, { header }).then((res) => {
    if (res.data.errorMessage) {
      throw new Error(res.data.errorMessage);
    }
    return res.data;
  });

export const getStoreList = ({ storeId, header }) =>
  instance
    .get("/owner-account-details/" + storeId, header)
    .then(({ data }) => data?.data || []);
